export default __webpack_public_path__ + "static/media/icon-close-black.07867337.svg";